import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './components/login/login.component';
import { LoginGuard } from './guards/login.guard';
import { AuthGuard } from './guards/auth.guard';
import { employeeGuard } from './guards/employee.guard';
import { SidebarGuard } from './guards/sidebar.guard';
import { LegalComponent } from './components/legal/legal.component';
import { FaqsComponent } from './components/faqs/faqs.component';

const routes: Routes = [
  { path: 'login', component: LoginComponent, canActivate: [LoginGuard] },
  { path: 'dashboard', loadComponent: () => import('./components/dashboard/dashboard.component').then(c => c.DashboardComponent), canActivate: [AuthGuard] },
    { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
  {
    path: 'quotations',
    canActivate: [AuthGuard, SidebarGuard],
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./quotation/quotation-list/quotation-list.component').then(
            (c) => c.QuotationListComponent
          ),
      },
      {
        path: 'details',
        loadComponent: () =>
          import(
            './quotation/quotation-detail/quotation-detail.component'
          ).then((c) => c.QuotationDetailComponent),
      },
    ],
  },
  {
    path: 'employees',
    canActivate: [employeeGuard, SidebarGuard],
    loadChildren: () =>
      import('./employee/employee.module').then((m) => m.EmployeeModule),
  },
  {
    path: 'documents',
    canActivate: [AuthGuard, SidebarGuard],
    loadComponent: () =>
      import('./components/document/document.component').then(
        (c) => c.DocumentComponent
      ),
  },
  {
    path: 'job-history',
    canActivate: [AuthGuard, SidebarGuard],
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./quotation/quotation-list/quotation-list.component').then(
            (c) => c.QuotationListComponent
          ),
      },
      {
        path: 'details',
        loadComponent: () =>
          import(
            './quotation/quotation-detail/quotation-detail.component'
          ).then((c) => c.QuotationDetailComponent),
      },
    ],
  },
  {
    path: 'cancelled-jobs',
    canActivate: [AuthGuard, SidebarGuard],
    loadComponent: () =>
      import('./quotation/quotation-list/quotation-list.component').then(
        (c) => c.QuotationListComponent
      ),
  },
  {
    path: 'profile',
    canActivate: [AuthGuard, SidebarGuard],
    loadChildren: () =>
      import('./profile/profile.module').then((m) => m.ProfileModule),
  },
  {
    path: 'reviews',
    canActivate: [AuthGuard, SidebarGuard],
    loadComponent: () =>
      import('./components/review-list/review-list.component').then(
        (c) => c.ReviewListComponent
      ),
  },
  {
    path: 'chat',
    canActivate: [AuthGuard, SidebarGuard],
    loadComponent: () =>
      import('./components/chat/chat.component').then((c) => c.ChatComponent),
  },

  {
    path: 'orders',
    canActivate: [AuthGuard, SidebarGuard],
    children: [
      {path: '',
      loadComponent: () =>
        import('./components/product/orders/orders.component').then(
          (c) => c.OrdersComponent
        ),
      },
      {
        path: 'details/:id',
        loadComponent: () =>
          import('./components/product/orders/order-detail/order-detail.component').then(
            (c) => c.OrderDetailComponent
          ),
      }
    ]
    
  },
  {
    path: 'menu',
    canActivate: [AuthGuard, SidebarGuard],
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./components/product/menu/menu.component').then(
            (c) => c.MenuComponent
          ),
      },
    ],
  },
  {
    path: 'products',
    canActivate: [AuthGuard, SidebarGuard],
    children: [
      {
        path: '',
        loadComponent: () =>
          import(
            './components/product/product-list/product-list.component'
          ).then((c) => c.ProductListComponent),
      },
      {
        path: 'details/:id',
        loadComponent: () =>
          import(
            './components/product/product-detail/product-detail.component'
          ).then((c) => c.ProductDetailComponent),
      },
    ],
  },
  {
    path: 'ratings-reviews',
    loadComponent: () =>
      import(
        './components/ratings-reviews/ratings-reviews.component'
      ).then((c) => c.RatingsReviewsComponent),
    canActivate: [AuthGuard, SidebarGuard],
  },
  // {
  //   path: 'store-timmings',
  //   loadComponent: () =>
  //     import(
  //       './components/product/store-timmings/store-timmings.component'
  //     ).then((c) => c.StoreTimmingsComponent),
  //   canActivate: [AuthGuard],
  // },
  {
    path: 'store-profile',
    canActivate: [AuthGuard, SidebarGuard],
    loadComponent: () =>
      import('./profile/store-profile/store-profile.component').then(
        (m) => m.StoreProfileComponent
      ),
  },
  {
    path: 'faqs',
    canActivate: [AuthGuard],
    component: FaqsComponent
  },
  {
    path: 'legal',
    canActivate: [AuthGuard],
    component: LegalComponent
  },

  { path: '**', redirectTo: 'dashboard' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
